export default {
  projectSelected: null,
};
